import React from 'react';
import { type ComparisonItemSourceFields, fieldTypeMap } from '../../../../../types/BaselineMeasurements';
import { Typography } from '@mui/material';
import { useLocale } from '../../../../../components/Intl';
import formatter from '../../../../../utils/formatter';

type Props = {
  field: keyof ComparisonItemSourceFields;
  value: ComparisonItemSourceFields[keyof ComparisonItemSourceFields];
  discrepanciesFields: string[];
};

export const ComparisonEventsListRowDetailField = ({ field, value, discrepanciesFields }: Props) => {
  const { locale } = useLocale();

  const getFormattedFieldValue = React.useCallback(
    ({
      field,
      value,
    }: {
      field: keyof ComparisonItemSourceFields;
      value: ComparisonItemSourceFields[keyof ComparisonItemSourceFields];
    }) => {
      if (value === null) {
        return '-';
      }

      if (field === 'logMissingData') {
        return '-';
      }
      const fieldType = fieldTypeMap[field];

      if (fieldType === 'percentage' && typeof value === 'number') {
        return formatter.percentageFormat({ value, locale });
      }
      if (fieldType === 'date') {
        return formatter.date(value);
      }
      if (fieldType === 'boolean') {
        return formatter.yesNo(value);
      }
      if (fieldType === 'currency' && typeof value === 'number') {
        const result = formatter.currencyFormat({ value, locale });

        return result === '' ? value : result;
      }

      return value;
    },
    [locale],
  );

  return (
    <Typography
      color="#263238"
      sx={{
        ...(discrepanciesFields.includes(field) && {
          bgcolor: '#fee2e2',
          color: '#991b1b',
          px: 0.5,
          py: 0.5,
          borderRadius: 1,
          fontWeight: 'bold',
        }),
      }}
    >
      {getFormattedFieldValue({ field, value })}
    </Typography>
  );
};
